import { schemaLoanRequestResolver_GetSummaryItem } from 'cpool-tables/backend-resolvers';

import { skipInvalidItems } from '~/queryUtils/skipInvalidItems';

export const schemaLeadSummaryList = skipInvalidItems(schemaLoanRequestResolver_GetSummaryItem, 'LeadList');
